import * as React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

function SvgPatterning(props) {
	return (
		<SvgIcon {...props}>
			<g stroke="currentColor" strokeWidth={1.2} fill="none" fillRule="evenodd">
				<circle cx={12} cy={12} r={8} />
				<circle cx={12} cy={12} r={5} />
				<circle cx={12} cy={12} r={2} />
			</g>
		</SvgIcon>
	)
}

export default SvgPatterning
